var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCatAnimation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "cat-svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.6396 50.1909C42.905 49.0224 45.4728 48.3638 48.1969 48.3638H58.2348",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9727 44.1764C31.9727 44.1764 32.3366 37.5007 36.4752 35.4993C31.9727 23.401 42.213 17.8785 42.213 17.8785C42.213 17.8785 46.936 2.33349 64.5132 2.26173C82.0904 2.18998 86.2342 17.1533 86.2342 17.1533C86.2342 17.1533 97.3484 24.4901 92.3358 34.9509C100.326 44.1764 94 53.5 94 53.5",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8284 48.0393H81.3237C90.5557 48.0393 98.0393 55.4931 98.0393 64.6884V80.4099C98.0393 89.6051 90.5557 97.0589 81.3237 97.0589H32.353",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cat-path",
    d: "M39.5405 48.8456C39.8916 46.839 40.5579 42.3287 39.6994 41.2473C38.8281 40.1479 34.7253 43.3922 32.9827 44.8555C31.6194 44.4634 30.1664 44.2507 28.6544 44.2507C27.1424 44.2507 25.6279 44.4737 24.239 44.8837C22.5143 43.4332 18.3679 40.1428 17.4915 41.2499C16.6151 42.3544 17.3249 47.0133 17.6709 48.9609C15.772 51.0802 14.6367 53.7582 14.6367 56.6744C14.6367 63.5347 20.9126 69.0956 28.657 69.0956C36.4013 69.0956 42.6772 63.5347 42.6772 56.6744C42.6772 53.7069 41.501 50.9854 39.5431 48.8507L39.5405 48.8456Z",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7503 62.9555C44.0817 65.1415 46.283 68.9111 46.283 73.1959V87.07C46.283 92.5464 41.8445 96.9849 36.3682 96.9849H20.6053C15.1289 96.9849 10.6904 92.5464 10.6904 87.07V73.1959C10.6904 68.8112 12.9968 64.9646 16.4615 62.8018",
    stroke: "white",
    className: "cat-path",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3726 97.0589H48.9658C46.288 97.0589 44.1177 94.4264 44.1177 91.1765C44.1177 87.9293 46.288 85.2942 48.9658 85.2942H81.3726",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.26172 70.4717V56.3797C2.26172 54.0529 4.14783 52.1667 6.47471 52.1667C8.8016 52.1667 10.6877 54.0529 10.6877 56.3797V86.3448",
    stroke: "white",
    className: "cat-path",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.26172 75V74.5771",
    stroke: "white",
    className: "cat-path",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8355 42.7773V48.756C70.8355 52.2361 68.014 55.0575 64.534 55.0575C61.0539 55.0575 58.2324 52.2361 58.2324 48.756V42.7773",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7858 15.4824C67.7858 24.1262 59.5777 23.9827 59.5777 23.9827H51.7334V31.3913C51.7334 38.4514 57.4584 44.1764 64.5184 44.1764C71.5785 44.1764 77.3035 38.4514 77.3035 31.3913V24.1262C77.3035 24.1262 70.2562 25.4332 67.2784 21.3663",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6992 34.9509C62.6992 34.9509 64.2983 37.4213 66.4048 34.9509",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2051 96.9874V79.8945",
    stroke: "white",
    className: "cat-path",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.937 96.9874V79.8945",
    stroke: "white",
    className: "cat-path",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6543 96.9875V77.519",
    stroke: "white",
    className: "cat-path",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3439 88.7048H24.513C26.7989 88.7048 28.6542 90.5602 28.6542 92.8461V96.9873H20.2026V92.8461C20.2026 90.5602 22.058 88.7048 24.3439 88.7048V88.7048Z",
    className: "cat-path",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7954 88.7048C35.0813 88.7048 36.9367 90.5602 36.9367 92.8461V96.9873H28.6567V92.8461C28.6567 90.5602 30.5121 88.7048 32.798 88.7048H32.7954Z",
    className: "cat-path",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5544 57.0664H30.0663C31.3092 57.0664 32.0857 58.153 31.4655 59.0243L30.7096 60.0826L29.9536 61.141C29.3334 62.0098 27.7779 62.0098 27.1577 61.141L26.4018 60.0826L25.6458 59.0243C25.0256 58.1555 25.8021 57.0664 27.045 57.0664H28.5569H28.5544Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M54.25 85.3633V96.9875",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4764 41.9906C17.4899 42.0031 17.5098 42.0031 17.5235 41.9906C17.6218 41.8998 17.9953 41.5401 17.9999 41.3018C18.0052 41.0273 17.75 41.0019 17.75 41.0019C17.75 41.0019 17.6149 40.9785 17.5251 41.0958C17.5122 41.1127 17.4878 41.1127 17.4749 41.0958C17.3851 40.9785 17.25 41.0019 17.25 41.0019C17.25 41.0019 16.9948 41.0273 17.0001 41.3018C17.0047 41.5401 17.3782 41.8998 17.4765 41.9906H17.4764Z",
    className: "cat-path",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "open-heart"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0608 22.0914C17.3094 22.3067 17.6758 22.3067 17.927 22.0914C19.7362 20.5385 26.6118 14.3804 26.6963 10.3007C26.7937 5.60336 22.0964 5.16771 22.0964 5.16771C22.0964 5.16771 19.6106 4.76794 17.9577 6.77449C17.7194 7.06407 17.2709 7.06407 17.0326 6.77449C15.3797 4.76794 12.8939 5.16771 12.8939 5.16771C12.8939 5.16771 8.19659 5.60336 8.29397 10.3007C8.37854 14.3804 15.2541 20.5385 17.0634 22.0914H17.0608Z",
    stroke: "#FF7900",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cat-path",
    d: "M1.96094 79.4119V88.6007C1.96094 93.2723 5.69316 97.0589 10.2976 97.0589H19.608",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatAnimation);
export default __webpack_public_path__ + "static/media/cat-animation.7248de84f9c93eb7824cf74f1f6181ca.svg";
export { ForwardRef as ReactComponent };